// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1274":"68829ef0","8714":"1f569f91"}[chunkId] + ".chunk.css";
};